import i18next from 'i18next'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Document } from '../../../components'
import { SectionNavigator } from '../../../components/Sections'
import { ImageSection } from '../../../components/modals/LoginModal/Sections'
import { AuthSectionNavigatorConfig } from '../../../components/modals/LoginModal/Sections/AuthSectionNavigatorConfig'
import modalCss from '../../../components/modals/LoginModal/LoginModal.module.scss'
import { ApplicationState } from '../../../store'
import css from './AuthLoginPage.module.scss'

export const AuthLoginPage = (): React.ReactElement => {
	const profile = useSelector((state: ApplicationState) => state.profile)
	const location = useLocation()
	const navigate = useNavigate()

	const title = i18next.t('pages.pageTitles.login')

	useEffect(() => {
		if (!profile.loggedIn) {
			return
		}

		const searchParams = new URLSearchParams(location.search)
		const redirect = searchParams.get('redirect')

		const getRedirectPath = (redirectTarget: string): string => {
			if (redirectTarget.includes('http')) {
				try {
					return new URL(redirectTarget).pathname
				} catch {
					return redirectTarget.split('?')[0]
				}
			}

			return redirectTarget.split('?')[0]
		}

		const isAuthLoginRedirect = (redirectTarget: string | null): boolean => {
			if (!redirectTarget) {
				return false
			}

			const redirectPath = getRedirectPath(redirectTarget)
			return redirectPath === '/auth/login' || redirectPath.endsWith('/auth/login')
		}

		if (!redirect || isAuthLoginRedirect(redirect)) {
			navigate('/', { replace: true })
			return
		}

		if (redirect.includes('http')) {
			window.location.href = redirect
			return
		}

		navigate(redirect, { replace: true })
	}, [profile.loggedIn, location.search, navigate])

	return (
		<Document title={title} description="Login" keywords="Login">
			<div className={css.page}>
				<div className={css.container}>
					<div className={modalCss['container']}>
						<ImageSection />
						<SectionNavigator config={AuthSectionNavigatorConfig} section="SignInSection" />
					</div>
				</div>
			</div>
		</Document>
	)
}
